const PinkSection = ({ children }) => {
	return (
		<section>
			<div className="wrap  relative mx-auto" style={{ backgroundImage: 'url("' + process.env.PUBLIC_URL + '/images/sectionMiddle.png")' }}>
				{children}
			</div>
		</section>
	)
}

export default PinkSection
